<template>
  <div class="login-page">
    <!-- 左側品牌區域 -->
    <div class="brand-section">
      <div class="brand-content">
        <div class="logo-area">
          <div class="logo-icon">🏢</div>
          <h1 class="company-name">安裕和國際企業社</h1>
          <p class="company-subtitle">Ann Yoo Hoh Company</p>
          <div class="tagline">管理後台系統</div>
        </div>
      </div>
    </div>

    <!-- 右側登入表單區域 -->
    <div class="form-section">
      <div class="form-container">
        <div class="login-card">
          <div class="card-header">
            <h2>管理員登入</h2>
            <p>歡迎回來,請登入您的帳號</p>
          </div>

          <form @submit.prevent="handleLogin" class="login-form">
            <!-- 帳號輸入 -->
            <div class="form-group">
              <label for="username" class="form-label">
                <span class="label-icon">
                  <img src="@/assets/image/icon/user.png" class="all-icon"
                /></span>
                帳號
              </label>
              <input
                id="username"
                type="text"
                class="form-input"
                v-model="formData.username"
                placeholder="請輸入帳號或電子郵件"
                required
                autocomplete="username"
              />
            </div>

            <!-- 密碼輸入 -->
            <div class="form-group">
              <label for="password" class="form-label">
                <span class="label-icon"
                  ><img src="@/assets/image/icon/lock.png" class="all-icon"
                /></span>
                密碼
              </label>
              <div class="password-input-wrapper">
                <input
                  id="password"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-input"
                  v-model="formData.password"
                  placeholder="請輸入密碼"
                  required
                  autocomplete="current-password"
                />
                <button
                  type="button"
                  class="toggle-password"
                  @click="showPassword = !showPassword"
                  :aria-label="showPassword ? '隱藏密碼' : '顯示密碼'"
                >
                  <img
                    :src="
                      showPassword
                        ? require('@/assets/image/icon/show.png')
                        : require('@/assets/image/icon/unshow.png')
                    "
                    class="password-icon"
                    alt="顯示密碼切換"
                  />
                </button>
              </div>
            </div>

            <!-- 記住帳號選項 -->
            <!-- <div class="form-options">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="formData.rememberMe"
                  class="checkbox-input"
                />
                <span class="checkbox-text">記住帳號</span>
              </label>
            </div> -->

            <!-- 登入按鈕 -->
            <button type="submit" class="btn-login" :disabled="isLoading">
              <span v-if="!isLoading">登入</span>
              <span v-else class="loading-spinner">
                <span class="spinner"></span>
                登入中...
              </span>
            </button>

            <!-- 錯誤訊息 -->
            <div v-if="errorMessage" class="error-message">
              ⚠️ {{ errorMessage }}
            </div>
          </form>

          <!-- 頁尾資訊 -->
          <div class="form-footer">
            <p>© 2026 安裕和國際企業社. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="@/assets/js/login.js"></script>
<style scoped src="@/assets/css/login.css"></style>
